function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Avatar, HStack, Pressable, Stack, VStack, useMediaQuery } from 'native-base';
import { Typography, BorderedCard, Iconography, colors } from 'fmc-digital-common';
import Functions from './TileCard.util';
import TextReplacer from '../../../../components/atoms/TextReplacer';
import { get } from 'lodash';
const TileCard = ({
  template: {
    header: {
      title,
      referenceTitle
    },
    body,
    subbody,
    alertdetail,
    callToActions
  },
  onClickHandle
}) => {
  const [isSmallScreen] = useMediaQuery({
    maxWidth: 766
  });
  const alertBox = {
    info: {
      color: get(colors, 'lightBlue.200', ''),
      icon: ''
    },
    warning: {
      color: get(colors, 'warning.100', ''),
      icon: /*#__PURE__*/React.createElement(Avatar, {
        height: 6,
        width: 6,
        bgColor: get(colors, 'warning.900', '')
      }, /*#__PURE__*/React.createElement(Iconography, {
        name: 'notifications-active-circle',
        size: 18,
        color: 'white.500'
      }))
    },
    success: {
      color: get(colors, 'success.100', ''),
      icon: /*#__PURE__*/React.createElement(Iconography, {
        name: 'check-circle',
        size: 26,
        color: 'success.300'
      })
    }
  };
  const loanNumberTxt = Functions.getLoanNumberByContent(referenceTitle);
  return /*#__PURE__*/React.createElement(BorderedCard, {
    padding: isSmallScreen ? 4 : 8,
    width: isSmallScreen ? 'fit-content' : 'auto',
    borderLeftColor: 'blue.900',
    borderLeftWidth: 8,
    borderRightWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 0,
    borderRadius: 4,
    shadow: 6,
    bgColor: 'white',
    isOpen: true
  }, /*#__PURE__*/React.createElement(Stack, {
    direction: isSmallScreen ? 'column' : 'row',
    space: isSmallScreen ? 4 : 8
  }, /*#__PURE__*/React.createElement(VStack, {
    space: 4,
    flex: isSmallScreen ? 'none' : 3
  }, /*#__PURE__*/React.createElement(VStack, {
    justifyContent: 'space-evenly',
    space: 2
  }, /*#__PURE__*/React.createElement(VStack, null, referenceTitle ? /*#__PURE__*/React.createElement(Typography, {
    variant: "body16",
    fontWeight: 500,
    color: get(colors, 'blue.900', ''),
    lineHeight: 18.75,
    testID: "tile-referenceTitle",
    accessibilityRole: "text",
    accessibilityLabel: "tile-referenceTitle"
  }, loanNumberTxt) : null), /*#__PURE__*/React.createElement(VStack, {
    justifyContent: 'center'
  }, /*#__PURE__*/React.createElement(Typography, _extends({
    variant: "title2",
    fontWeight: 400,
    color: get(colors, 'darkGray.900', ''),
    lineHeight: 36.33
  }, title?.metadata ? title?.metadata : {}), /*#__PURE__*/React.createElement(TextReplacer, {
    metadata: title?.metadata,
    content: title?.content
  }))), /*#__PURE__*/React.createElement(VStack, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body16",
    fontWeight: 400,
    color: get(colors, 'review.500', ''),
    lineHeight: 18.75
  }, /*#__PURE__*/React.createElement(TextReplacer, {
    metadata: body[0]?.metadata,
    content: body[0]?.content
  })))), /*#__PURE__*/React.createElement(VStack, null, subbody?.content ? /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle",
    fontWeight: 400,
    color: get(colors, 'darkGray.900', ''),
    lineHeight: 15.23,
    testID: "tile-loan-status",
    accessibilityRole: "text",
    accessibilityLabel: "tile-loan-status"
  }, Functions.getSubbodyByContent(subbody?.metadata?.values)) : null)), /*#__PURE__*/React.createElement(VStack, {
    flex: 2,
    space: isSmallScreen ? 4 : 2,
    justifyContent: 'center'
  }, /*#__PURE__*/React.createElement(Stack, {
    space: 2,
    backgroundColor: `${alertBox[alertdetail?.varient]?.color}`,
    padding: 4,
    borderRadius: 8,
    minH: 101,
    maxH: 'fit-content'
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(VStack, {
    flex: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body20",
    fontWeight: 400,
    color: get(colors, 'darkGray.900', ''),
    lineHeight: 23.44
  }, /*#__PURE__*/React.createElement(TextReplacer, {
    metadata: alertdetail?.header?.metadata,
    content: alertdetail?.header?.content
  }))), /*#__PURE__*/React.createElement(VStack, {
    variant: "body16"
  }, alertBox[alertdetail?.varient]?.icon)), /*#__PURE__*/React.createElement(VStack, {
    flex: 1
  }, alertdetail?.subbody ? /*#__PURE__*/React.createElement(Typography, {
    variant: "body16",
    fontWeight: 400,
    color: get(colors, 'darkGray.900', ''),
    lineHeight: 18.75,
    testID: "tile-status-info",
    accessibilityRole: "text",
    accessibilityLabel: "tile-status-info"
  }, Functions.getAlertSubbodyContent(alertdetail?.subbody)) : null)), /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => onClickHandle(loanNumberTxt.split(':')[1])
  }, /*#__PURE__*/React.createElement(HStack, {
    space: 2,
    justifyContent: 'center'
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body16",
    fontWeight: 500,
    textTransform: 'uppercase',
    color: get(colors, 'blue.900', ''),
    lineHeight: 18.75
  }, /*#__PURE__*/React.createElement(TextReplacer, {
    metadata: callToActions[0]?.metadata,
    content: callToActions[0]?.content
  })), /*#__PURE__*/React.createElement(Typography, {
    display: 'flex',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: 'arrow-forward',
    size: 20,
    color: 'blue.900'
  })))))));
};
export default TileCard;
//# sourceMappingURL=TileCard.js.map